import { businessData } from "data/businessData";
import styled from "styled-components";

const StyledSection = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const StyledWrapper = styled.div`
  width: 100%;
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  align-items: center;
  padding: 1rem 2rem;
  margin-bottom: 2rem;
  h2 {
    font-size: 3rem;
    line-height: 4.2rem;
    font-weight: 700;
    width: 100%;
    text-align: center;
    margin-bottom: 0;
    @media screen and (max-width: 1280px) {
      margin: 2rem 0 0 0;
    }
    @media screen and (max-width: 992px) {
      line-height: 2.8rem;
      font-size: 2rem;
    }
    @media screen and (max-width: 768px) {
      text-align: left;
    }
  }
  p {
    text-align: center;
    font-size: 1.2rem;
    line-height: 2rem;
    margin-bottom: 4rem;
    @media screen and (max-width: 768px) {
      text-align: left;
      margin-bottom: 1rem;
    }
  }
  @media screen and (max-width: 768px) {
    margin-bottom: 0;
  }
`;

const SubHero = () => {
  return (
    <StyledSection>
      <StyledWrapper>
        <h2>{businessData.sectionOneTitle}</h2>
        <p>{businessData.sectionOneSubtitle}</p>
      </StyledWrapper>
    </StyledSection>
  );
};

export default SubHero;
